module.exports = __webpack_public_path__ + "media/images/services/07-941ca0e6e821c47e9e6043ea905a33ca.jpg";